import { TabPanel as ChakraTabPanel, TabProps } from '@chakra-ui/react';

export function TabPanel({ children }: TabProps): JSX.Element {
  return <ChakraTabPanel>{children}</ChakraTabPanel>;
}
